import React, { Component } from 'react';
import Collapsible from 'react-collapsible';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import api from '../../../axios-local-api';
import Spinner from '../../../components/UI/Spinner/Spinner';
import Box from '../../../hoc/Box/Box';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../../store/actions/index';
import classes from './PodPerformance.css';
import { EquipmentTypes } from '../../../shared/common';

class PodPerformance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      upArrow: false,
    };
    //this.setEquipmentSelection = this.setEquipmentSelection.bind(this);
  }

  setEquipmentSelection(data, type) {
    this.props.onSetSelectedEquipment({
      routerId: this.props.realWan.id,
      podId: data.id,
      serialNumber: data.serialNumber,
      nickname: data.nickname,
      defaultName: data.defaultName,
      ip: data.ip || 'N/A',
      type: EquipmentTypes.Pod,
      claimed: type === EquipmentTypes.Pod ? true : false,
      podConnectionState: data.connectionState,
      displayAllEquipment: false,
      didClick: false,
    });
  }

  openHandler() {
    this.setState({
      upArrow: true,
    });
  }
  closeHandler() {
    this.setState({
      upArrow: false,
    });
  }

  getFreqBand = (freqBand) => {
    if (freqBand && (freqBand.includes('5G') || freqBand.includes('5g'))) {
      return '5GHz';
    } else if (
      freqBand &&
      (freqBand.includes('2.4G') || freqBand.includes('2.4g'))
    ) {
      return '2.4GHz';
    }
    return '';
  };
  getTableRowContent = (data, type, parentPod, deviceType) => {
    const colorCode = {
      connected: 'green',
      excellent: 'green',
      disconnected: 'red',
      poor: 'red',
      good: 'green',
      fair: 'red',
      calculating: 'orange',
    };
    let connectedTo = 'N/A';

    let connectedDevice = 'N/A';
    let deviceName;
    let model;
    let qoeScore = 'N/A';

    let signalStatus = data.health ? data.health.status : 'disconnected';
    if (type === EquipmentTypes.Pod) {
      //console.log(data.health);
      if (data.connectionState === 'disconnected' || data.connectionState === 'calculating') {
        connectedDevice = 'N/A';
      } else {
        connectedDevice = !data.health
          ? 'N/A'
          : data.health && data.health.status === 'disconnected'
            ? 'N/A'
            : data.backhaulType === 'ethernet'
              ? 'Ethernet'
              : data.backHaul && data.backHaul.metadata
                ? `${this.getFreqBand(data.backHaul.metadata.freqBand)}/${data.backHaul.metadata.channel
                }`
                : connectedDevice;
      }
      connectedTo = !data.health
        ? 'N/A'
        : data.health && data.health.status === 'disconnected'
          ? 'N/A'
          : data.backhaulType === 'ethernet'
            ? 'Ethernet'
            : parentPod
              ? parentPod.nickname || parentPod.defaultName
              : connectedTo;
      deviceName = data.nickname ? data.nickname : data.defaultName;
      model = data.model;
      signalStatus =
        data.backhaulType === 'ethernet' ? 'Connected' : signalStatus;
      if (
        this.props.wan &&
        (this.props.wan.checkingWan ||
          (this.props.wan.podTimer && this.props.wan.rebootPodId === data.id))
      ) {
        signalStatus = 'disconnected';
      }
      if (
        // data.health === null ||
        // data.health === 'null' ||
        (data.health && data.health.score)
      ) {
        qoeScore = data.health.score;
      }
    } else if (type === 'unclaimedpod') {
      // console.log(data.health);
      connectedDevice = 'N/A';
      connectedTo = 'N/A';
      deviceName = data.serialNumber;
      model = data.vendorModel;
      signalStatus = 'unclaimed';
    }
    let colorStyleCode = '#6F777E';
    let colorClassname;

    if (signalStatus === 'disconnected') {
      colorStyleCode = colorCode.disconnected;
      colorClassname = classes.disconnected;
    } else {
      colorStyleCode = data.health
        ? colorCode[data.health.status]
        : colorCode.disconnected;
      colorClassname = data.health
        ? classes[data.health.status]
        : classes.disconnected;
    }

    const colorDot = (
      <div
        className={classes.colorDot}
        style={{ display: 'flex', alignItems: 'center' }}
      >
        <div className={colorClassname}></div>
        <div style={{ width: '10px' }} />
        <div
          id="signal"
          className={classes.statusName}
          style={{ color: colorStyleCode }}
        >
          {signalStatus}
        </div>
      </div>
    );

    if (deviceName && deviceName.length > 12) {
      deviceName = deviceName.substring(0, 12) + '...';
    }

    if (deviceType === 'Mobile') {
      return (
        <Box>
          <tr>
            <td
              style={{
                padding: '16px',
                borderRight: 'none',
                borderLeft: 'none',
                wordBreak: 'break-word',
                width: '140px',
                whiteSpace: 'normal',
              }}
            >
              <Link
                to={{
                  pathname: '/overview',
                  query: {
                    wifiServiceCheck: true,
                    type: EquipmentTypes.Pod,
                    itemId: data.id,
                  },
                }}
                style={{ color: '#0073d1', textDecoration: 'none' }}
                onClick={() => {
                  this.setEquipmentSelection(data, type);
                }}
              >
                {deviceName}
              </Link>
            </td>{' '}
          </tr>
        </Box>
      );
    } else {
      let connectedDeviceWithColor;
      if (connectedDevice.includes('2.4GHz')) {
        connectedDeviceWithColor = (
          <td
            className={classes.connection_column}
            style={{
              padding: '10px',
              borderRight: 'none',
              borderLeft: 'none',
              // color: 'red',
            }}
          >
            {connectedDevice}
          </td>
        );
      } else {
        if (connectedDevice === 'ethernet') {
          connectedDevice = 'Ethernet';
        }
        connectedDeviceWithColor = (
          <td
            id="EquipmentConnection"
            className={classes.connection_column}
            style={{ padding: '10px', borderRight: 'none', borderLeft: 'none' }}
          >
            {connectedDevice}
          </td>
        );
      }
      return (
        <tr className={classes.trTag}>
          <td
            id="PodEquipmentName"
            style={{ padding: '16px', borderRight: 'none', borderLeft: 'none' }}
            className={[classes.showDesktop, classes.showDesktop1].join(' ')}
          >
            <Link
              id="PodLink"
              to={{
                pathname: '/overview',
                query: { wifiServiceCheck: true, type: EquipmentTypes.Pod, itemId: data.id },
              }}
              style={{ color: '#0073d1', textDecoration: 'none' }}
              onClick={() => {
                this.setEquipmentSelection(data, type);
              }}
            >
              {deviceName}
            </Link>
          </td>

          <td
            id="PodEquipmentSignal"
            style={{ padding: '16px', borderRight: 'none', borderLeft: 'none' }}
          >
            {colorDot}
          </td>
          {connectedDeviceWithColor}

          <td
            id="PodEquipmentConnectedTo"
            style={{ padding: '10px', borderRight: 'none', borderLeft: 'none' }}
          >
            {connectedTo}
          </td>
          <td
            id="PodEquipmentModel"
            style={{ padding: '10px', borderRight: 'none', borderLeft: 'none' }}
          >
            {model}
          </td>
          {/* <td
            id="PodEquipmentQoEScore"
            style={{ padding: '10px', borderRight: 'none', borderLeft: 'none' }}
          >
            {qoeScore}
          </td> */}
        </tr>
      );
    }
  };

  getEquipmentStatusRows = (deviceType = '') => {
    const realWan = this.props.realWan;
    const claimedPods = this.props.claimedPods;
    const unclaimedPods = this.props.unclaimedPods;
    const equipmentStatusContent = [];
    if (!realWan) {
      return undefined;
    }

    if (claimedPods && claimedPods.length) {
      let router = {
        id: realWan.id,
        mac: realWan.mac,
        //Wanted to display name as Router in the connectedTo column if the parent is Router
        nickname: 'Router',
      };
      let claimedPodMap = claimedPods.reduce((acc, cpod) => {
        acc[cpod.id] = cpod;
        return acc;
      }, {});
      claimedPodMap[router.id] = router;
      let filterclaimedPods = claimedPods.filter((pod) => {
        if (
          pod.connectionState === 'disconnected' ||
          pod.connectionState === 'poor' ||
          pod.connectionState === 'Poor' ||
          pod.connectionState === 'unavailable'
        ) {
          return true;
        }
        return false;
      });
      claimedPods.forEach((pod) => {
        // Restricting the display of ethernet connected pod
        if (pod.backhaulType === 'ethernet') {
          return;
        }
        // Adding condition for filtering qoepods if its called from wifi sevice check        
        if (this.props.qoePods && !this.props.qoePods.includes(pod.id)) {
          return;
        }

        let parentId =
          pod.leafToRoot && pod.leafToRoot.length
            ? pod.leafToRoot[0].id
            : undefined;
        let parentPod;
        if (parentId) {
          parentPod = claimedPodMap[parentId];
        } else {
          parentPod = router;
        }
        equipmentStatusContent.push(
          this.getTableRowContent(pod, EquipmentTypes.Pod, parentPod, deviceType)
        );
      });
    }

    if (!this.props.qoePods && unclaimedPods && unclaimedPods.length) {
      let router = {
        id: realWan.id,
        mac: realWan.mac,
        //Wanted to display name as Router in the connectedTo column if the parent is Router
        nickname: 'Router',
      };
      let unClaimedPodMap = unclaimedPods.reduce((acc, cpod) => {
        acc[cpod.id] = cpod;
        return acc;
      }, {});
      unClaimedPodMap[router.id] = router;
      unclaimedPods
        .filter((pod) => {
          if (
            pod.connectionState === 'disconnected' ||
            pod.connectionState === 'Poor' ||
            pod.connectionState === 'calculating' ||
            pod.connectionState === 'unavailable'
          ) {
            return true;
          }
          return false;
        })
        .forEach((pod) => {
          // Restricting the display of ethernet connected pod
          if (pod.backhaulType === 'ethernet') {
            return;
          }
          let parentId =
            pod.leafToRoot && pod.leafToRoot.length
              ? pod.leafToRoot[0].id
              : undefined;
          let parentPod;
          if (parentId) {
            parentPod = unClaimedPodMap[parentId];
          } else {
            parentPod = router;
          }
          equipmentStatusContent.push(
            this.getTableRowContent(pod, 'unclaimedpod', parentPod, deviceType)
          );
        });
    }

    return equipmentStatusContent;
  };
  render() {
    let arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    if (this.state.upArrow || this.props.wifiServicePodsFailedCount > 1) {
      arrow = <MdKeyboardArrowUp color={'gray'} size={'30px'} />;
    } else {
      arrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    }

    let infoRow;
    let equipNameData;
    if (this.props.loading || !this.props.loaded) {
      infoRow = <Spinner />;
    } else {
      infoRow = (
        <div>
          <div className={classes.showMobile} style={{ float: 'left' }}>
            <table className={classes.devTable} cellPadding="0" cellSpacing="0">
              <thead>
                <tr>
                  <th
                    style={{
                      borderLeft: 'none',
                      borderRight: 'none',
                      textAlign: 'left',
                      padding: '16px',
                      color: 'grey',
                    }}
                  >
                    Equip. Name
                  </th>
                </tr>
              </thead>
              <tbody>{this.getEquipmentStatusRows('Mobile')}</tbody>
            </table>
          </div>

          <div className={classes.tablewrapper}>
            <table className={classes.devTable} cellPadding="0" cellSpacing="0">
              <thead>
                <tr className={classes.trTag}>
                  <th
                    className={classes.showDesktop}
                    style={{
                      borderLeft: 'none',
                      borderRight: 'none',
                      textAlign: 'left',
                      padding: '16px',
                      color: 'grey',
                    }}
                  >
                    Equip. Name
                  </th>

                  <th
                    style={{
                      borderLeft: 'none',
                      borderRight: 'none',
                      textAlign: 'left',
                      padding: '16px',
                      color: 'grey',
                    }}
                  >
                    Signal
                  </th>
                  <th
                    style={{
                      borderLeft: 'none',
                      borderRight: 'none',
                      textAlign: 'left',
                      padding: '16px',
                      color: 'grey',
                    }}
                  >
                    Connection
                  </th>
                  <th
                    style={{
                      borderLeft: 'none',
                      borderRight: 'none',
                      textAlign: 'left',
                      padding: '10px',
                      color: 'grey',
                    }}
                  >
                    Connected To
                  </th>
                  <th
                    style={{
                      borderLeft: 'none',
                      borderRight: 'none',
                      textAlign: 'left',
                      padding: '10px',
                      color: 'grey',
                    }}
                  >
                    Model #
                  </th>
                  {/* <th
                    id='PodPerformanceQoEScore'
                    style={{
                      borderLeft: 'none',
                      borderRight: 'none',
                      textAlign: 'left',
                      padding: '10px',
                      color: 'grey',
                    }}
                  >
                    QoE Score
                  </th> */}
                </tr>
              </thead>
              <tbody>{this.getEquipmentStatusRows('Desktop')}</tbody>
            </table>
          </div>
        </div>
      );
    }
    let openCollapsible =
      this.props.wifiServicePodsFailedCount > 0 ? true : false;
    return (
      <Box>
        <div className={classes.PodPerformanceComponent}>
          <Collapsible
            open={openCollapsible}
            transitionTime={100}
            onOpening={() => {
              this.openHandler();
            }}
            onClosing={() => {
              this.closeHandler();
            }}
            trigger={
              <Box>
                <div className={classes.PodPerformanceComponentCollapse}>
                  <div className={classes.TitleArea}>
                    <h3 style={{ paddingRight: 20 }}>Extender Performance</h3>

                    <button
                      id="PodPerformanceArrow"
                      className={classes.OpenCloseButton}
                      style={{ float: 'right' }}
                      aria-label="open arrow"
                    >
                      {arrow}
                    </button>
                  </div>

                  <div className={classes.HorizontalSeparator} />
                </div>
              </Box>
            }
          >
            {infoRow}
          </Collapsible>
        </div>
      </Box>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    loading: state.equipment.loading,
    loaded: state.equipment.loaded,
    realWan: state.wan.realWan,
    equipment: state.equipment,
    claimedPods:
      state.equipment && state.equipment.realEquipment
        ? state.equipment.realEquipment.claimedPods
        : [],
    unclaimedPods:
      state.equipment && state.equipment.realEquipment
        ? state.equipment.realEquipment.unclaimedPods
        : [],
    wan: state.wan,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onInitWan: () => dispatch(actions.initWan()),
    onInitEquipment: () => {
      dispatch(actions.initEquipment());
    },
    refreshDevices: () => dispatch(actions.refreshDevices()),
    onSetSelectedEquipment: (equipment) => {
      dispatch(actions.setSelectedEquipment(equipment));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(PodPerformance, api));
